import EmptyTrashImage from "@/assets/images/empty-trash.svg?react";
import { EmptyContainer, EmptyText } from "@/components/styling/empty";

export const TrashPageListEmpty = () => {
  return (
    <EmptyContainer>
      <EmptyTrashImage />
      <EmptyText>No notes in trash</EmptyText>
    </EmptyContainer>
  );
};
